import React from 'react';
import classNames from 'classnames/bind';
import { linksInformation } from './linksInformation';
import styles from './mulch-calculator-links.module.scss';

const cx = classNames.bind(styles);

export const MulchCalculatorLinks = () => {

  return (
    <div className={cx('mulch-calculator-links')} data-component="MulchCalculatorLinks">
      {
        linksInformation.map((guide, index) => {
          return (
            <div key={index} className={cx('mulch-calculator-links__group')}>
              <div key={index} className={cx('mulch-calculator-links__title')}>
                {guide.title}
              </div>
              {guide.content.map((content, i) => {
                return (
                  <div key={i}>
                    <a
                      key={content.description}
                      className={cx('mulch-calculator-links__anchor')}
                      target="_blank"
                      rel="noreferrer"
                      href={content.link}
                    >
                      {content.description}
                    </a>
                  </div>
                );
              })}
            </div>
          );
        })
      }
    </div>
  );
};
